import { get } from "lodash";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import FormattedCharge from "./FormattedCharge.jsx";

class ChargeFromEstimate extends PureComponent {
  static propTypes = {
    estimate: PropTypes.object,
    resourceKey: PropTypes.string.isRequired,
    dimension: PropTypes.string.isRequired
  };

  static defaultProps = {
    dimension: "weekly"
  };

  render() {
    const { estimate, resourceKey, dimension } = this.props;

    if (!estimate) return null;

    const chargeData = get(
      estimate,
      `${resourceKey}.${dimension}.charge`,
      null
    );

    return <FormattedCharge chargeData={chargeData} />;
  }
}

export default ChargeFromEstimate;
